export default "<app-right-aside-energy></app-right-aside-energy>\n"